var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.history") } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage overflow-hidden" },
          [
            _c(
              "b-row",
              [
                _c("b-col", [
                  _c(
                    "div",
                    { staticClass: "requestsList" },
                    [
                      _c(
                        "f7-list",
                        { staticClass: "mb-2" },
                        [
                          _c(
                            "f7-list-item",
                            { class: _vm.additionalClass },
                            [
                              _c(
                                "b-row",
                                {
                                  staticClass:
                                    "no-gutter justify-content-start",
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass:
                                        "btn btnFilter btn-secondary",
                                      on: {
                                        click: function ($event) {
                                          return _vm.refreshInbox()
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-light fa-rotate-right",
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "f7-list-item",
                            {
                              staticClass:
                                "filter-item-section showLargeScreenOnly",
                            },
                            [
                              _c(
                                "b-row",
                                { staticClass: "min-w-100" },
                                [
                                  _c(
                                    "b-col",
                                    { staticClass: "d-flex flex-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "filter-item" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "filter-item-title text-ellipsis",
                                              attrs: {
                                                title: _vm.$t(
                                                  "common.date_start_label"
                                                ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "common.date_start_label"
                                                    )
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "filter-item-content",
                                            },
                                            [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  staticClass: "z-0",
                                                  class: {
                                                    "filter-item-input": true,
                                                    "filter-item-input-complete":
                                                      _vm.dateBegin,
                                                  },
                                                  attrs: {
                                                    inputIcon:
                                                      "fa-solid fa-calendar text-info",
                                                    inputType: "datetime",
                                                    disablePastDates: "",
                                                    labelClass: "",
                                                  },
                                                  model: {
                                                    value: _vm.dateBegin,
                                                    callback: function ($$v) {
                                                      _vm.dateBegin = $$v
                                                    },
                                                    expression: "dateBegin",
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "filter-item" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "filter-item-title text-ellipsis",
                                              attrs: {
                                                title: _vm.$t(
                                                  "common.date_end_label"
                                                ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "common.date_end_label"
                                                    )
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "filter-item-content",
                                            },
                                            [
                                              _c(
                                                "form-write-group-label-input",
                                                {
                                                  staticClass: "z-1",
                                                  class: {
                                                    "filter-item-input": true,
                                                    "filter-item-input-complete":
                                                      _vm.dateEnd,
                                                  },
                                                  attrs: {
                                                    inputIcon:
                                                      "fa-solid fa-calendar text-info",
                                                    colLabelSize: 4,
                                                    colInputSize: 8,
                                                    inputType: "datetime",
                                                    disablePastDates: "",
                                                    inputClass: " w-100",
                                                    labelClass: "",
                                                  },
                                                  model: {
                                                    value: _vm.dateEnd,
                                                    callback: function ($$v) {
                                                      _vm.dateEnd = $$v
                                                    },
                                                    expression: "dateEnd",
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "filter-item" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "filter-item-title",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("common.action_type")
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "filter-item-content",
                                            },
                                            [
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.actionType,
                                                      expression: "actionType",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "pt-1 z-2 h-auto cursor fs-14px-important",
                                                  attrs: {
                                                    id: "select-action-type",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      var $$selectedVal =
                                                        Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function (o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function (o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                      _vm.actionType = $event
                                                        .target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "option",
                                                    { attrs: { value: "" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "history.slct_actn"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.actionList,
                                                    function (label, type) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: type,
                                                          attrs: {
                                                            title: label,
                                                          },
                                                          domProps: {
                                                            value: type,
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(label))]
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c("i", {
                                                ref: "select-action-type",
                                                staticClass:
                                                  "fa-light fa-chevron-down p-1 z-1 float-right cursor mt--22px-important",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "filter-item" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "filter-item-title",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("common.user"))
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "filter-item-content",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.user,
                                                    expression: "user",
                                                  },
                                                ],
                                                class: {
                                                  "filter-item-input": true,
                                                  "filter-item-input-complete":
                                                    _vm.user,
                                                },
                                                attrs: {
                                                  type: "text",
                                                  placeholder:
                                                    _vm.$t("common.user"),
                                                },
                                                domProps: { value: _vm.user },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.user =
                                                      $event.target.value
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "d-flex mt-4",
                                      attrs: { cols: "3" },
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "btn mr-2",
                                          attrs: {
                                            size: "sm",
                                            disabled: !_vm.hasInputFilter,
                                          },
                                          on: { click: _vm.clearFilterFields },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t("filter.clr_fltr_field")
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "btn",
                                          attrs: { size: "sm" },
                                          on: { click: _vm.applyFilter },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(_vm.$t("filter.fltr")) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.activateSpinner
                        ? _c("spinner")
                        : _c(
                            "div",
                            [
                              _vm.inboxMessages.length
                                ? _c("b-table", {
                                    staticClass: "table mt-3 text-center",
                                    attrs: {
                                      hover: "",
                                      borderless: "",
                                      outlined: "",
                                      items: _vm.inboxMessages,
                                      fields: _vm.historyFields,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "cell(dateAction)",
                                          fn: function (data) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "cursor text-ellipsis",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      attrs: {
                                                        title: data.value,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatDateTime"
                                                          )(data.value)
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3183465032
                                    ),
                                  })
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-center mt-5",
                                    },
                                    [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(_vm.$t("common.no_result"))
                                        ),
                                      ]),
                                    ]
                                  ),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.activateSpinner
              ? _c(
                  "b-row",
                  { staticClass: "mt-1" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c("cm-pagination", {
                          attrs: {
                            maxResultsByPage: _vm.paginationObject.maxResults,
                            firstIndex: _vm.paginationObject.firstIndex,
                            nbResultsTotal: _vm.paginationObject.nbResultsTotal,
                            refreshEvent: _vm.paginationObject.refresh,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }